var exports = {
  "kL": "xe564cbfb--5af156--container",
  "MI": "xe564cbfb--5af156--container--inner",
  "JN": "xe564cbfb--5af156--heading-section",
  "Tj": "xe564cbfb--5af156--map",
};

module.exports = exports;
